/** AutoMapa dealer portal i18n — Spanish Colombia (es-CO). Merged into automotive.dealerPortal at build time. */
export default {
  common: {
    apply: "Aplicar",
    retry: "Reintentar",
    back: "Volver",
    cancel: "Cancelar",
    close: "Cerrar",
    save: "Guardar",
    edit: "Editar",
    view: "Ver",
    viewAll: "Ver todos",
    loading: "Cargando…",
    whatsapp: "WhatsApp",
    period: "Periodo",
    quality: "Calidad",
    active: "Activos",
    public: "Públicos",
    noTimeline: "Sin plazo",
    team: "equipo",
    newCount: "{count} nuevos",
    activeCount: "{count} activos",
    alertsCount: "{count} alertas",
    viewOnAutoMapa: "Ver en AutoMapa",
    noDataInPeriod: "Sin datos en este periodo.",
    exportCsv: "Exportar CSV",
    backToDashboard: "Volver al dashboard",
    minSuffix: " min",
    viewsCount: "{count} vistas",
  },
  errors: {
    generic: "No se pudo cargar esta página.",
    loadDashboard: "No se pudo cargar el dashboard.",
    loadLeads: "No se pudo cargar leads.",
    loadLead: "Lead no encontrado.",
    loadInventory: "No se pudo cargar el inventario.",
    loadReports: "Error al cargar reportes.",
    loadPlan: "No se pudo cargar tu plan.",
    loadOnboarding: "No se pudo cargar el onboarding.",
    updateOnboarding: "No se pudo actualizar este paso del onboarding.",
    loadImport: "No se pudo cargar la importación.",
    updateLead: "No se pudo actualizar el lead.",
    saveNote: "Error al guardar nota.",
    actionFailed: "Acción fallida.",
    duplicateFailed: "No se pudo duplicar.",
    serverUnexpected: "El servidor encontró un error inesperado. Intenta de nuevo en un momento.",
    network: "No se pudo conectar con el servidor. Revisa tu conexión e intenta de nuevo.",
    dealerNotFound: "Concesionario no encontrado.",
    loadSponsorships: "No se pudieron cargar los patrocinios.",
    submitUpgrade: "No se pudo enviar la solicitud de upgrade.",
    upgrade_pending: "Ya tienes una solicitud de upgrade pendiente para este plan.",
    upgrade_not_higher: "Selecciona un plan superior a tu plan actual.",
    upgrade_invalid_plan: "Selecciona un plan válido para el upgrade.",
    authRequired: "Tu sesión de concesionario expiró. Inicia sesión de nuevo e inténtalo otra vez.",
    accessDenied: "No tienes acceso para solicitar un upgrade de este concesionario.",
    notFound: "Esta acción no está disponible ahora. Actualiza la página o contacta a AutoMapa si continúa.",
    badRequest: "No pudimos procesar esta solicitud de upgrade. Revisa tu selección e inténtalo de nuevo.",
    validationFailed: "No pudimos procesar esta solicitud de upgrade. Revisa el formulario e inténtalo de nuevo.",
    http_404: "No encontramos el servicio de upgrade. Puede que la API necesite reiniciarse — actualiza e inténtalo de nuevo.",
    http_409: "Ya tienes una solicitud de upgrade pendiente para este plan.",
  },
  sponsorships: {
    title: "Marketing pagado · Boosts",
    subtitle: "Promociona vehículos con ubicación patrocinada en la búsqueda de AutoMapa. Los boosts son add-ons pagos además de tu plan de concesionario.",
    marketingEyebrow: "Marketing pagado",
    marketingTitle: "Llega a más compradores con visibilidad patrocinada",
    marketingBody:
      "Los boosts en búsqueda colocan tus vehículos en posiciones premium cuando los compradores buscan en AutoMapa. Es marketing adicional pagado — aparte de tu plan mensual — y cada boost corre por un periodo fijo una vez aprobado.",
    marketingPoint1: "Tú eliges el vehículo y el tipo de ubicación antes de solicitar.",
    marketingPoint2: "AutoMapa revisa elegibilidad, programa el boost y lo etiqueta claramente como «Destacado» para compradores.",
    marketingPoint3: "Se te factura cada periodo de boost aprobado. Los costos se acumulan conforme activas más campañas.",
    pricingTitle: "Precios de boost",
    pricingPerWeek: "{price} / semana",
    pricingDefaultDuration: "Campaña típica: {days} días al aprobarse",
    pricingNote: "Las fechas finales y la factura las confirma AutoMapa tras la revisión. Los montos son estimados en COP.",
    spendTitle: "Tu compromiso de marketing",
    spendTotal: "Total comprometido",
    spendActive: "Boosts activos (restante)",
    spendScheduled: "Boosts programados",
    spendPending: "Solicitudes pendientes",
    spendHint: "Gasto estimado acumulado de boosts en curso, programados o pendientes de aprobación.",
    spendEmpty: "Aún no tienes boosts pagos. Cuando solicites y apruebes boosts, verás el total aquí.",
    newBoostEstimate: "Esta solicitud suma aprox. {price} por {days} días",
    newBoostTotalAfter: "Compromiso total tras aprobación: aprox. {price}",
    loading: "Cargando patrocinios…",
    viewPlan: "Tu plan",
    upgradeCta: "Revisar opciones de plan",
    totalLikes: "Me gusta de compradores",
    likedVehicles: "{count} vehículos con likes",
    activeBoosts: "Boosts activos",
    pendingRequests: "Solicitudes pendientes",
    popularTitle: "Vehículos más populares",
    popularHint: "Ordenados por guardados (♥) en los últimos 30 días. Impulsa publicaciones activas para convertir interés en visibilidad.",
    popularEmpty: "Aún no hay likes. Cuando los compradores guarden tus vehículos, aparecerán aquí.",
    likes: "Likes",
    boostStatus: "Estado boost",
    notBoosted: "Sin boost",
    boost: "Boost",
    cannotBoostInactive: "Activa esta publicación antes de impulsarla",
    manageTitle: "Solicitar boost pagado en búsqueda",
    manageIntro: "Selecciona un vehículo, elige el tipo de ubicación y revisa el costo estimado antes de enviar la solicitud.",
    selectVehicle: "Elige un vehículo",
    selectVehicleHint: "Busca y filtra tu inventario activo, luego selecciona un vehículo para impulsar.",
    vehicleSearchPlaceholder: "Buscar por vehículo o ciudad…",
    vehicleFilterLabel: "Mostrar",
    vehicleFilterAll: "Todos activos",
    vehicleFilterAvailable: "Disponibles para boost",
    vehicleFilterBoosted: "Ya con boost",
    vehicleSortLabel: "Ordenar",
    vehicleSortAlpha: "Vehículo A–Z",
    vehicleSortPriceAsc: "Precio: menor a mayor",
    vehicleSortPriceDesc: "Precio: mayor a menor",
    vehicleResultsCount: "{shown} de {total} vehículos",
    vehiclePickerEmpty: "Ningún vehículo coincide con tu búsqueda. Prueba otro término o filtro.",
    selectedVehicle: "Vehículo seleccionado",
    changeVehicle: "Cambiar",
    stepVehicle: "1. Vehículo",
    stepPlacement: "2. Ubicación",
    stepReview: "3. Revisar y enviar",
    marketingToggle: "Cómo funcionan los boosts pagos",
    insightsTitle: "Señales de desempeño",
    paginationPrev: "Anterior",
    paginationNext: "Siguiente",
    paginationPage: "Página {page} de {total}",
    noBoostableVehicles: "No tienes publicaciones activas para impulsar.",
    addInventoryCta: "Agregar o activar inventario",
    boostType: "Tipo de ubicación",
    boostTypeHint: "Las ubicaciones premium cuestan más porque reciben mayor visibilidad.",
    requestNote: "Nota para AutoMapa (opcional)",
    requestPlaceholder: "Ciudad objetivo, fechas de campaña o por qué debería destacarse este vehículo…",
    requestBoost: "Solicitar boost · {price}",
    submitting: "Enviando…",
    requestSent: "Solicitud enviada. AutoMapa revisará precio y programación antes de activar.",
    selectListingRequired: "Selecciona un vehículo activo para impulsar.",
    defaultRequestMessage: "Solicitud de boost desde portal dealer",
    alreadyBoosted: "boost activo",
    activeBoostsTitle: "Boosts pagos activos",
    noActiveBoosts: "No hay boosts activos. Solicita uno para un vehículo con buen desempeño.",
    scheduledTitle: "Boosts programados",
    pendingRequestsTitle: "Solicitudes pendientes",
    recentTitle: "Boosts recientes",
    costRemaining: "Restante: {price}",
    costTotal: "Campaña: {price}",
    costEstimated: "Est. {price}",
    durationDays: "{days} días",
    placementStatus: {
      draft: "Borrador",
      scheduled: "Programado",
      active: "Activo",
      paused: "Pausado",
      expired: "Expirado",
      cancelled: "Cancelado",
      rejected: "Rechazado",
    },
    boostTypes: {
      search_top_slot: {
        label: "Top de búsqueda",
        description: "Máxima visibilidad — tu vehículo aparece arriba en resultados relevantes.",
      },
      search_inline_slot: {
        label: "Boost inline en búsqueda",
        description: "Ubicación patrocinada mientras los compradores navegan resultados.",
      },
      featured_listing: {
        label: "Publicación destacada",
        description: "Slot patrocinado estándar con etiqueta clara «Destacado» para compradores.",
      },
    },
  },
  dateRanges: {
    today: "Hoy",
    last_7_days: "Últimos 7 días",
    last_30_days: "Últimos 30 días",
    this_month: "Este mes",
    trial_period: "Periodo de prueba",
  },
  dashboard: {
    loadErrorTitle: "No pudimos cargar tu dashboard",
    heroEyebrow: "Panel del concesionario",
    heroTitle: "Hola, {name}",
    heroIntro: "Resumen de {period}. Prioriza leads calientes, mantén tu inventario actualizado y revisa señales de desempeño.",
    viewLeads: "Ver leads",
    reports: "Reportes",
    respondLeads: "Responder leads",
    addVehicle: "Agregar vehículo",
    reviewInventory: "Revisar inventario",
    publicProfile: "Perfil público",
    emptyTitle: "Empieza a recibir señales útiles",
    emptyBody: "Publica inventario activo y responde leads para ver embudo, engagement y alertas de calidad en este panel.",
    importInventory: "Importar inventario",
    insightTitle: "Lo más relevante ahora",
    kpiActiveListings: "Inventario activo",
    kpiNewLeads: "Leads nuevos",
    kpiHotLeads: "Leads calientes",
    kpiLeadsInPeriod: "Leads en periodo",
    kpiWhatsappClicks: "Clics WhatsApp",
    kpiResponseTime: "Tiempo de respuesta",
    hotLeadsTitle: "Leads calientes",
    hotLeadsEmpty: "No hay leads calientes en este periodo. Revisa leads nuevos y responde rápido.",
    viewLead: "Ver lead",
    funnelTitle: "Embudo de leads",
    funnelInPeriod: "{count} en periodo",
    funnelNew: "Nuevos",
    funnelContacted: "Contactados",
    funnelTestDrive: "Test drive",
    funnelNegotiating: "Negociando",
    funnelSold: "Vendidos",
    conversionRate: "Conversión: {rate}%",
    topListingsTitle: "Top vehículos",
    topListingsEmpty: "Publica inventario activo para ver desempeño por vehículo.",
    popularTitle: "Más gustados por compradores",
    popularEmpty: "Cuando los compradores marquen ♥ tus publicaciones, aparecerán aquí.",
    popularHint: "Basado en guardados de compradores en este periodo.",
    viewSponsorships: "Administrar boosts",
    likesCount: "{count} likes",
    checklistTitle: "Acciones recomendadas",
    checklistComplete: "Todo al día en las tareas principales.",
    alertsTitle: "Alertas de inventario",
    alertsEmpty: "Sin alertas operativas urgentes.",
    profileHealthTitle: "Salud del perfil",
    inventoryEngagementTitle: "Inventario y engagement",
    statActive: "Activos",
    statPublic: "Públicos",
    statMissingPhotos: "Sin fotos",
    statListingViews: "Vistas listings",
  },
  leads: {
    inboxTitle: "Bandeja de leads",
    hotTitle: "Leads calientes",
    archivedTitle: "Leads archivados",
    inboxSubtitle: "Compradores interesados en tu inventario y solicitudes compatibles.",
    allNew: "Todos",
    hot: "Calientes",
    contacted: "Contactados",
    testDrives: "Test drives",
    sold: "Vendidos",
    archived: "Archivados",
    searchPlaceholder: "Buscar nombre, teléfono, ciudad…",
    allStatuses: "Todos los estados",
    sourcePage: "Fuente (página)",
    campaign: "Campaña",
    leadsReport: "Reporte leads",
    loading: "Cargando leads…",
    empty: "Aún no tienes leads. Cuando un comprador contacte tus vehículos o complete una solicitud compatible, aparecerá aquí.",
    updateFailed: "No se pudo actualizar el lead.",
    hotPill: "Caliente",
    actionPlaceholder: "Acción…",
    table: {
      buyer: "Comprador",
      whatsapp: "WhatsApp",
      type: "Tipo",
      status: "Estado",
      score: "Score",
      temperature: "Temperatura",
      vehicleInterest: "Vehículo / interés",
      city: "Ciudad",
      timeline: "Timeline",
      date: "Fecha",
      actions: "Acciones",
    },
  },
  inventory: {
    searchPlaceholder: "Buscar marca/modelo",
    allStatuses: "Todos los estados",
    addVehicle: "Agregar vehículo",
    importCsv: "Importar CSV",
    loading: "Cargando inventario…",
    empty: "Aún no tienes vehículos publicados. Agrega tu primer vehículo para empezar a recibir compradores calificados.",
    photo: "Foto",
    vehicle: "Vehículo",
    price: "Precio",
    mileage: "Km",
    city: "Ciudad",
    status: "Estado",
    availability: "Disponibilidad",
    fairPrice: "Precio justo",
    risk: "Riesgo",
    actions: "Acciones",
    confirm: "Confirmar",
    reserve: "Reservar",
    soldAction: "Vendido",
    pause: "Pausar",
    duplicate: "Duplicar",
    pageSubtitle: "Revisa, actualiza y gestiona los vehículos que ven los compradores en AutoMapa.",
    sortLabel: "Ordenar",
    resultsCount: "{count} vehículos",
    moreActions: "Más",
    viewPublic: "Ver en AutoMapa",
    publicListingUnavailable: "Publicación pública no disponible",
    publicListingSyncPending: "La publicación pública aún se está sincronizando",
    noPhoto: "Sin foto",
  },
  inventoryDetail: {
    loading: "Cargando vehículo…",
    notFound: "Vehículo no encontrado.",
    backToInventory: "← Inventario",
    editListing: "Editar publicación",
    viewPublic: "Ver en AutoMapa",
    featuredActive: "Destacado activo",
    featuredUntil: "Hasta {date}",
    requestFeatured: "Solicitar destacar",
    photosTitle: "Galería",
    noPhotos: "Sin fotos — agrega imágenes para mejorar conversión.",
    managePhotosTitle: "Gestionar fotos",
    managePhotosIntro:
      "Agrega, reordena o elimina imágenes. La primera foto es la portada en búsqueda y en la página pública.",
    savePhotos: "Guardar fotos",
    savingPhotos: "Guardando fotos…",
    savePhotosFailed: "No se pudieron guardar las fotos.",
    statsViews: "Vistas",
    statsLeads: "Leads",
    statsQuality: "Calidad",
    statsLastConfirmed: "Última confirmación",
    neverConfirmed: "Sin confirmar",
    specsTitle: "Datos del vehículo",
    transmission: "Transmisión",
    fuel: "Combustible",
    bodyType: "Carrocería",
    color: "Color",
    version: "Versión",
    descriptionTitle: "Descripción",
    noDescription: "Sin descripción. Agrega detalles para ayudar a los compradores.",
    warningsTitle: "Pendientes",
    fairPriceTitle: "Precio de mercado",
    fairPriceLabel: "Etiqueta",
    fairPriceMedian: "Mediana comparable",
    fairPriceComparables: "Comparables",
    fairPriceDelta: "Diferencia vs mercado",
    fairPriceHighHint:
      "Este precio está por encima de publicaciones similares. Destaca beneficios en la descripción.",
    riskTitle: "Señales de revisión",
    riskIntro: "Corrige estas señales para mejorar confianza y conversión.",
    riskNone: "No hay señales pendientes.",
    riskEditLink: "Editar publicación",
    riskQualityLink: "Ver calidad del inventario",
    buyerSection: "Interés de compradores",
    workflowTitle: "Estado del vehículo",
    workflowIntro: "Mantén el inventario actualizado para generar confianza.",
    confirmAvailable: "Confirmar disponible",
    markReserved: "Marcar reservado",
    markSold: "Marcar vendido",
    pause: "Pausar publicación",
    reactivate: "Reactivar",
    archive: "Archivar",
    actionFailed: "No se pudo completar la acción.",
  },
  inventoryForm: {
    addTitle: "Agregar vehículo",
    editTitle: "Editar vehículo",
    loading: "Cargando vehículo…",
    backToListing: "Volver al detalle",
    backToInventory: "Volver al inventario",
    qualityScore: "Calidad del anuncio",
    intro:
      "Usa el menú lateral para saltar entre secciones. Los campos con * son obligatorios para publicar.",
    sectionNavTitle: "Secciones",
    sidebarTitle: "Ayuda y acciones",
    actionsTitle: "Guardar cambios",
    expandSection: "Mostrar",
    collapseSection: "Ocultar",
    tipsTitle: "Consejos rápidos",
    tips: {
      photos: "📸 Mínimo 3 fotos claras (exterior, interior, tablero).",
      price: "💰 Precio y kilometraje exactos generan más confianza.",
      docs: "📋 SOAT y tecnomecánica vigentes mejoran la calidad del anuncio.",
    },
    sections: {
      photos: "Fotos",
      vehicle: "Vehículo",
      sale: "Precio y ubicación",
      listing: "Publicación",
      documents: "Documentos",
      identity: "Identificación del vehículo",
      pricing: "Precio y disponibilidad",
      specs: "Especificaciones técnicas",
      location: "Ubicación del vehículo",
    },
    sectionDescriptions: {
      photos: "La foto #1 es la portada en búsqueda. Agrega al menos 3 fotos claras.",
      vehicle: "Marca, modelo, año y especificaciones mecánicas en un solo lugar.",
      sale: "Precio, disponibilidad y dónde pueden ver el vehículo.",
      listing: "Descripción de venta y referencias internas para tu equipo.",
      documents: "Control interno. Placa y VIN no se muestran al público.",
      identity: "Datos básicos del vehículo. Deben coincidir con la tarjeta de propiedad o factura.",
      pricing: "Información comercial visible en AutoMapa. Revisa que el precio esté en pesos colombianos (COP).",
      specs: "Características mecánicas que los compradores usan para filtrar y comparar.",
      location: "Dónde pueden ver o retirar el vehículo. Mejora la relevancia en búsquedas locales.",
    },
    sectionEmojis: {
      photos: "📸",
      vehicle: "🚗",
      sale: "💰",
      listing: "✍️",
      documents: "📋",
      identity: "🚗",
      pricing: "💰",
      specs: "⚙️",
      location: "📍",
    },
    documentPrivacyNote: "🔒 Placa, VIN y stock interno solo los ve tu concesionario — no aparecen en la ficha pública.",
    photos: {
      helper: "La primera foto es la portada en AutoMapa. Agrega al menos 3 fotos para mejorar conversión.",
      empty: "Aún no hay fotos. Sube imágenes desde tu computador o pega URLs.",
      primaryBadge: "Portada",
      addUrl: "Agregar URL",
      orAddUrl: "O pega una URL",
      addUrlPlaceholder: "https://ejemplo.com/foto.jpg",
      uploadHint: "JPG, PNG o WebP · máximo 8 MB por foto · hasta 20 fotos.",
      uploadFiles: "📤 Subir fotos",
      uploadingFiles: "Subiendo…",
      uploadedFileNote: "Archivo subido desde tu dispositivo.",
      uploadedFilePlaceholder: "Foto cargada localmente",
      moveUp: "Mover arriba",
      moveDown: "Mover abajo",
      setPrimary: "Usar como portada",
      remove: "Quitar",
      count: "{count} foto(s)",
      invalidUrl: "Ingresa una URL válida (http:// o https://).",
      tooMany: "Puedes agregar hasta 20 fotos por vehículo.",
      tooLarge: "Cada foto debe pesar menos de 8 MB.",
      invalidType: "Solo se permiten imágenes JPG, PNG o WebP.",
      emptyFile: "El archivo está vacío.",
      uploadFailed: "No se pudo procesar la imagen. Intenta con otro archivo.",
    },
    saveDraft: "Guardar borrador",
    save: "Guardar",
    saveAndPublish: "Guardar y publicar",
    documentStatus: {
      valid: "Vigente",
      expired: "Vencido",
      unknown: "Desconocido",
      not_provided: "No informado",
    },
    fields: {
      make: "Marca",
      model: "Modelo",
      version: "Versión / trim",
      year: "Año",
      priceCop: "Precio (COP)",
      mileageKm: "Kilometraje (km)",
      transmission: "Transmisión",
      fuel: "Combustible",
      bodyType: "Tipo de carrocería",
      color: "Color",
      engineSize: "Cilindraje",
      doors: "Puertas",
      city: "Ciudad",
      neighborhood: "Barrio",
      address: "Dirección",
      availabilityStatus: "Disponibilidad",
      description: "Descripción",
      financingAvailable: "Financiación disponible",
      internalPlate: "Placa (interno)",
      internalVin: "VIN (interno)",
      soatStatus: "SOAT",
      tecnomecanicaStatus: "Tecnomecánica",
      ownershipCount: "Número de propietarios",
      accidentHistoryNote: "Historial de accidentes",
      dealerStockNumber: "Stock interno",
      externalListingUrl: "URL externa",
    },
    fieldHints: {
      make: "Ej. Toyota, Renault, Chevrolet — como la reconocen los compradores.",
      model: "Línea del vehículo: Corolla, Duster, Onix…",
      version: "Trim o versión (XLE, Sport, LTZ). Opcional si no aplica.",
      year: "Año modelo según tarjeta de propiedad o factura.",
      bodyType: "SUV, sedán, pickup… ayuda en filtros de búsqueda.",
      priceCop: "Precio de venta en pesos. Solo números, sin puntos ni $.",
      mileageKm: "Kilometraje actual del tablero en kilómetros.",
      availabilityStatus: "Indica si el vehículo se puede ver o entregar pronto.",
      financingAvailable: "Activa si ofreces crédito, leasing o plan de pagos.",
      transmission: "Manual, automática o CVT según corresponda.",
      fuel: "Gasolina, diésel, híbrido, eléctrico o GNV.",
      engineSize: "Ej. 1600 cc, 2.0L — opcional pero útil para comparar.",
      doors: "Cantidad de puertas (incluye portón en hatchback/SUV).",
      color: "Color exterior principal visible en fotos.",
      city: "Ciudad donde está el vehículo para visitas o entrega.",
      neighborhood: "Barrio o zona — mejora búsquedas locales en AutoMapa.",
      address: "Opcional. Dirección del lote o punto de entrega.",
      internalPlate: "Referencia interna. No se publica en AutoMapa.",
      internalVin: "Número de chasis para control de inventario. No es público.",
      soatStatus: "Seguro obligatorio: vigente, vencido o sin información.",
      tecnomecanicaStatus: "Revisión técnico-mecánica según normativa colombiana.",
      ownershipCount: "Propietarios anteriores + el actual. 1 = primer dueño.",
      accidentHistoryNote: "Siniestros, choques o reparaciones mayores. Sé transparente.",
      description: "Equipamiento, estado, garantías y por qué conviene este vehículo.",
      dealerStockNumber: "Código de inventario de tu concesionario (SKU interno).",
      externalListingUrl: "Enlace a tu web o marketplace si también publicas allí.",
    },
    required: " *",
  },
  reports: {
    nav: {
      hub: "Resumen",
      rendimiento: "Publicaciones",
      leads: "Leads",
      inventario: "Inventario",
      fuentes: "Fuentes",
    },
    hubTitle: "Reportes de rendimiento",
    hubDescription: "Mide vistas, contactos, leads e inventario en AutoMapa.",
    loading: "Cargando reportes…",
    listingViews: "Vistas de publicaciones",
    whatsappClicks: "Clics a WhatsApp",
    leadsReceived: "Leads recibidos",
    qualifiedLeads: "Leads calificados",
    activeInventory: "Inventario activo",
    inventoryFreshness: "Inventario actualizado",
    avgResponseTime: "Tiempo promedio de respuesta",
    insufficientResponseData: "Sin datos suficientes",
    featuredPlacement: "Ubicaciones destacadas",
    featuredIntro: "Estos resultados muestran interacciones generadas desde ubicaciones destacadas en AutoMapa.",
    impressions: "Impresiones",
    clicks: "Clics",
    topFeatured: "Top destacado",
    trialPerformance: "Rendimiento de tu prueba",
    daysRemaining: "Días restantes",
    views: "Vistas",
    inventoryFreshnessPct: "Frescura inventario",
    exploreReports: "Explorar reportes",
    listingPerformance: "Rendimiento por publicación",
    listingPerformanceDesc: "Vistas, WhatsApp, leads y acciones sugeridas por vehículo.",
    leadPerformance: "Rendimiento de leads",
    leadPerformanceDesc: "Calidad, fuentes, respuesta y desempeño por publicación.",
    inventoryReport: "Inventario",
    inventoryReportDesc: "Calidad, frescura y publicaciones que necesitan acción.",
    sourcesReport: "Fuentes",
    sourcesReportDesc: "De dónde vienen tus leads y clics de contacto.",
    recommendedActions: "Acciones recomendadas",
    respondLeads: "Responder leads",
    updateInventory: "Actualizar inventario",
    viewsOverTime: "Vistas en el tiempo",
    whatsappOverTime: "Clics WhatsApp en el tiempo",
    leadsOverTime: "Leads en el tiempo",
    demoNotice: "Mostrando datos de ejemplo. Las métricas en vivo aparecen cuando tu plan incluye reportes de rendimiento y tienes actividad en AutoMapa.",
    demoTopListing: "Toyota Corolla Cross 2022",
    cannedActions: {
      respondLeads: "Responde leads nuevos en menos de 2 horas para mejorar la conversión.",
      updatePhotos: "Agrega fotos a publicaciones sin imágenes.",
      confirmInventory: "Confirma disponibilidad en vehículos sin actualizar en 14+ días.",
    },
  },
  onboarding: {
    title: "Configura tu concesionario",
    subtitle: "Completa estos pasos para empezar a recibir compradores calificados en AutoMapa.",
    eyebrow: "Primeros pasos",
    loading: "Cargando tu checklist de onboarding…",
    progress: "Puntaje de readiness",
    status: "Estado",
    activeListings: "Publicaciones activas",
    photoCoverage: "Cobertura de fotos",
    freshness: "Disponibilidad confirmada",
    launchTarget: "Meta de lanzamiento",
    metricsTitle: "Métricas de lanzamiento",
    checklistTitle: "Tu checklist",
    checklistProgress: "{percent}% de los pasos requeridos completados",
    stepsComplete: "{completed} de {total} pasos completados",
    sectionProgress: "{completed} de {total} listos en esta sección",
    stepComplete: "Completo",
    stepPending: "Pendiente",
    nextUp: "Siguiente paso recomendado",
    markComplete: "Marcar como hecho",
    markingComplete: "Guardando…",
    adminReviewNote: "AutoMapa confirmará este paso después de revisarlo.",
    helpTitle: "¿Necesitas ayuda?",
    helpBody: "Sube inventario, confirma disponibilidad cada semana y responde leads con rapidez. El equipo de AutoMapa puede ayudarte con perfil y verificación.",
    launchReadyTitle: "Estás listo para lanzar",
    nextStepsTitle: "Siguientes pasos",
    ctaUploadInventory: "Carga tu inventario",
    ctaConfirmAvailability: "Confirma disponibilidad",
    ctaReviewLeads: "Revisa tus leads",
    ctaViewReports: "Ver reportes",
    launchReady: "Tu concesionario cumple los requisitos iniciales para recibir compradores en AutoMapa.",
    selectDealer: "Selecciona un concesionario en el portal.",
    metricActiveListings: "{current} de {target} publicaciones activas",
    metricPhotoCoverage: "{current}% de publicaciones con fotos (meta {target}%)",
    metricFreshness: "{current}% confirmadas recientemente (meta {target}%)",
    categories: {
      business_profile: "Perfil del concesionario",
      contact_channels: "Contacto y WhatsApp",
      verification: "Verificación",
      inventory: "Configuración de inventario",
      photos: "Fotos de publicaciones",
      leads: "Leads y enrutamiento",
      training: "Capacitación del portal",
      launch_readiness: "Aprobación de lanzamiento",
    },
    hints: {
      business_name_confirmed: "Confirma que el nombre público coincide con lo que conocen los compradores.",
      public_name_confirmed: "Revisa cómo aparece tu nombre en el perfil público de AutoMapa.",
      logo_added: "Agrega logo o foto de portada para que te reconozcan.",
      address_confirmed: "Confirma tu dirección física para confianza y búsqueda local.",
      city_neighborhood_confirmed: "Los compradores filtran por ciudad — confirma la tuya.",
      whatsapp_confirmed: "Tu WhatsApp principal recibe notificaciones de leads.",
      contact_person_confirmed: "Define quién responde leads en tu equipo.",
      public_profile_reviewed: "Abre tu perfil público y verifica que todo se vea bien.",
      verification_reviewed: "AutoMapa verifica la identidad del concesionario antes del lanzamiento.",
      inventory_file_received: "Comparte un CSV o archivo con tu inventario usado actual.",
      inventory_imported: "Importa vehículos al portal o publícalos manualmente.",
      listings_cleaned: "Corrige campos faltantes y publicaciones de baja calidad.",
      listings_have_photos: "Las publicaciones sin fotos no se muestran a compradores.",
      listings_have_price_mileage: "Cada publicación necesita precio y kilometraje.",
      listings_confirmed_available: "Confirma que los vehículos siguen en venta cada dos semanas.",
      min_ten_active_listings: "Publica al menos diez vehículos activos para generar confianza.",
      lead_inbox_reviewed: "Abre tu bandeja de leads y revisa solicitudes nuevas.",
      whatsapp_routing_tested: "Prueba que las notificaciones de WhatsApp lleguen correctamente.",
      dashboard_reviewed: "Revisa métricas y alertas en tu dashboard.",
      response_expectations_understood: "Responde leads nuevos en máximo dos horas cuando sea posible.",
      trial_terms_explained: "Revisa los límites de tu plan y términos de prueba.",
      launch_ready_approval: "AutoMapa da la aprobación final cuando se cumplen todos los requisitos.",
    },
    actions: {
      reviewProfile: "Revisar perfil público",
      contactAutoMapa: "Contactar AutoMapa",
      uploadInventory: "Subir inventario",
      reviewQuality: "Revisar calidad",
      addPhotos: "Agregar fotos faltantes",
      fixListings: "Corregir publicaciones",
      confirmAvailability: "Confirmar disponibilidad",
      addVehicles: "Agregar vehículos",
      openLeads: "Abrir leads",
      testWhatsapp: "Probar WhatsApp",
      openDashboard: "Abrir dashboard",
      readGuide: "Leer guía de respuesta",
      reviewPlan: "Revisar tu plan",
      awaitingApproval: "En revisión por AutoMapa",
      getStarted: "Comenzar",
    },
  },
  readiness: {
    not_started: "Sin iniciar",
    in_progress: "En progreso",
    needs_inventory: "Necesita inventario",
    needs_verification: "Necesita verificación",
    needs_cleanup: "Necesita limpieza",
    launch_ready: "Listo para lanzar",
    active: "Activo",
  },
  plan: {
    title: "Tu plan",
    subtitle: "Límites, features incluidos y uso del mes.",
    pageEyebrow: "💼 Facturación y planes",
    subtitleProfessional: "Consulta tu plan actual, el uso del mes y opciones claras de upgrade con precios.",
    loading: "Cargando tu plan…",
    contactAutoMapa: "💬 Hablar con AutoMapa",
    viewReports: "📊 Ver reportes",
    updateInventory: "Actualizar inventario",
    openLeads: "Abrir leads",
    activeListings: "Publicaciones activas",
    leadsThisMonth: "Leads del mes",
    reportsAccess: "Reportes",
    featuredEligible: "Visibilidad destacada",
    featuredEligibleYes: "Elegible",
    notIncluded: "No incluido",
    currentPlanTitle: "✅ Tu plan actual",
    currentPlanBadge: "Plan actual",
    currentPlanFootnote: "Este es el plan activo en tu cuenta hoy.",
    usageTitle: "📈 Uso del mes",
    upgradeTitle: "🚀 Opciones de upgrade",
    upgradeSubtitle: "Compara planes con precios y features. Los upgrades los activa el equipo AutoMapa.",
    upgradeCta: "Solicitar upgrade",
    upgradeToPlan: "Upgrade a {plan}",
    upgradeModalEyebrow: "Upgrade de plan",
    upgradeModalTitle: "Mejora el plan de tu concesionario",
    upgradeModalPlanIntro: "Elige el plan que se ajuste a tu inventario y volumen de leads. Confirmaremos precio y activaremos tu upgrade.",
    upgradeContinue: "Continuar",
    upgradeBack: "Atrás",
    upgradeSubmit: "Enviar solicitud de upgrade",
    upgradeSubmitting: "Enviando…",
    upgradeDone: "Listo",
    upgradeSelectPlanRequired: "Selecciona un plan para continuar.",
    upgradeReasonsIntro: "Cuéntanos qué necesitas para preparar el upgrade correcto.",
    upgradeMessageLabel: "¿Algo más que debamos saber? (opcional)",
    upgradeMessagePlaceholder: "Tamaño de inventario, fecha de lanzamiento, contacto de facturación o necesidades especiales…",
    upgradeComparisonTitle: "Qué cambia con este upgrade",
    upgradeTargetLabel: "Plan solicitado",
    upgradeEstimatedPrice: "Precio de referencia",
    upgradeReviewNote: "AutoMapa revisa cada solicitud manualmente. Recibirás confirmación antes de cualquier cambio de facturación.",
    upgradeSuccessTitle: "Solicitud de upgrade enviada",
    upgradeSuccessBody: "Tu solicitud está en la cola de AutoMapa. No hay cambios de plan hasta que confirmemos contigo.",
    upgradeSuccessStep1: "Nuestro equipo revisa tu inventario, volumen de leads y plan solicitado.",
    upgradeSuccessStep2: "Confirmamos el precio final y enviamos detalles de facturación si aplica.",
    upgradeSuccessStep3: "Tu nuevo plan se activa en el portal una vez aprobado.",
    upgradePendingTitle: "Solicitud de upgrade en curso",
    upgradePendingBody: "Ya solicitaste {plan}. AutoMapa la está revisando — te contactaremos pronto.",
    upgradePendingBanner: "Upgrade a {plan} solicitado el {date}. Estamos revisando tu solicitud.",
    upgradeReasons: {
      more_listings: "Necesito publicar más vehículos",
      more_leads: "Estoy llegando al límite mensual de leads",
      featured_placement: "Quiero ubicación destacada y boosts pagos",
      performance_reports: "Necesito reportes de desempeño",
      bulk_upload: "Necesito importación masiva CSV",
      priority_support: "Quiero soporte prioritario",
    },
    upgradeWhatsappMessage: "Hola AutoMapa, me interesa actualizar mi concesionario al plan {planName}.",
    recommendedBadge: "🌟 Más popular",
    topTierTitle: "Estás en nuestro plan estándar más alto",
    topTierBody: "¿Necesitas límites custom o términos enterprise? AutoMapa puede armar un plan a medida.",
    warningsTitle: "Alertas del plan",
    featuredSectionTitle: "⭐ Publicaciones destacadas",
    featuredRequestLabel: "Solicitar destacar una publicación",
    featuredUpgradeHint: "Actualiza a Growth o Premium para desbloquear ubicaciones destacadas en AutoMapa.",
    lockedFeaturesTitle: "🔒 Features fuera de tu plan",
    priceFree: "Gratis",
    priceMonthly: "{price} / mes",
    billingNote: "La facturación se gestiona manualmente con AutoMapa en esta fase. Aún no hay cobro automático en el portal.",
    faqTitle: "❓ Preguntas frecuentes",
    faqBillingQuestion: "¿Cómo funciona la facturación?",
    faqBillingAnswer: "Aún no hay checkout automático. AutoMapa confirma precio, envía factura y activa tu nuevo plan manualmente.",
    faqUpgradeQuestion: "¿Cómo hago upgrade?",
    faqUpgradeAnswer: "Elige un plan y haz clic en Solicitar upgrade. Completarás un formulario corto en el portal — sin WhatsApp. AutoMapa confirma precio y activa tu nuevo plan manualmente.",
    faqLimitsQuestion: "¿Qué pasa si supero los límites?",
    faqLimitsAnswer: "Tus publicaciones activas se mantienen, pero puede que no puedas publicar más hasta hacer upgrade. Los leads siguen registrándose.",
    featureSeoPage: "Página SEO del concesionario",
    featurePrioritySupport: "Soporte prioritario",
    featureBulkUpload: "Carga masiva CSV",
    planEmojis: {
      free: "🆓",
      starter: "🌱",
      growth: "🚀",
      premium: "💎",
      custom: "🛠️",
    },
    featuredTitle: "Publicaciones destacadas",
    featuredActive: "Activos",
    featuredScheduled: "Programados",
    featuredIntro: "Estos resultados muestran interacciones generadas desde ubicaciones destacadas en AutoMapa.",
    featuredRequestPlaceholder: "Mensaje para solicitar destacar una publicación",
    requestFeatured: "Solicitar destacar",
    requestSent: "Solicitud enviada. AutoMapa la revisará pronto.",
    featuredUpgrade: "Tu plan actual no incluye publicaciones destacadas. Habla con AutoMapa para revisar opciones.",
    featuredUpgradeCta: "Solicitar upgrade para publicaciones destacadas",
    lockedBulkTitle: "Carga masiva",
    lockedBulkDesc: "Tu plan no incluye importación CSV masiva. Contacta a AutoMapa para actualizar.",
    lockedReportsTitle: "Reportes de rendimiento",
    lockedReportsDesc: "Los reportes completos requieren un plan superior.",
    comparisonTitle: "Comparación de planes",
    comparisonPricingNote: "Precios mensuales de referencia en COP. El precio final se confirma con ventas AutoMapa.",
    colPlan: "Plan",
    colListings: "Listings",
    colLeads: "Leads/mes",
    colBulk: "Bulk",
    colReports: "Reportes",
    colFeatured: "Destacado",
    colPrice: "Precio",
    priceContact: "Consultar",
    unlimited: "Ilimitado",
    featureYes: "Sí",
    featureNo: "No",
    trialLabel: "Trial",
    trialStage: "Stage",
    reportsBasic: "Básico",
    reportsFull: "Completo",
    featuredDefaultRequest: "Solicitud desde portal del concesionario",
    trialStatus: {
      not_started: "No iniciado",
      active: "Activo",
      ending_soon: "Por vencer",
      expired: "Vencido",
      extended: "Extendido",
      converted: "Convertido",
      lost: "Perdido",
      paused: "Pausado",
      declined: "Declinado",
    },
    conversionStage: {
      no_conversation: "Sin conversación",
      value_review_scheduled: "Revisión agendada",
      value_review_completed: "Revisión completada",
      pricing_discussed: "Pricing discutido",
      proposal_sent: "Propuesta enviada",
      negotiation: "Negociación",
      converted: "Convertido",
      lost: "Perdido",
    },
    planLabels: {
      free: "Gratis",
      starter: "Starter",
      growth: "Growth",
      premium: "Premium",
      custom: "Personalizado",
    },
  },
  import: {
    steps: {
      upload: "Subir archivo",
      map: "Mapear campos",
      preview: "Vista previa",
      confirm: "Confirmar",
      results: "Resultados",
    },
    modes: {
      create_only: "Solo crear publicaciones nuevas",
      update_by_stock: "Actualizar por código de inventario",
      update_by_url: "Actualizar por URL externa",
      update_by_plate: "Actualizar por placa interna",
      create_and_update: "Crear y actualizar",
    },
    publishModes: {
      draft: "Importar como borrador",
      needs_review: "Enviar a revisión",
      active: "Publicar válidos de inmediato",
    },
    status: {
      uploaded: "Subido",
      mapping_required: "Mapeo requerido",
      preview_ready: "Listo para revisar",
      importing: "Importando…",
      completed: "Completado",
      completed_with_errors: "Completado con errores",
      failed: "Fallido",
      cancelled: "Cancelado",
    },
    duplicates: {
      exact_stock_match: "Coincidencia exacta (stock)",
      exact_url_match: "Coincidencia exacta (URL)",
      exact_plate_match: "Coincidencia exacta (placa)",
      likely_duplicate: "Duplicado probable",
      possible_duplicate: "Posible duplicado",
      no_match: "Sin coincidencia",
    },
    rowActions: {
      create: "Crear",
      update: "Actualizar",
      skip: "Omitir",
      needs_review: "Revisión",
    },
    fields: {
      make: "Marca",
      model: "Modelo",
      version: "Versión",
      year: "Año",
      priceCop: "Precio (COP)",
      mileageKm: "Kilometraje",
      transmission: "Transmisión",
      fuel: "Combustible",
      bodyType: "Carrocería",
      color: "Color",
      city: "Ciudad",
      neighborhood: "Barrio",
      address: "Dirección",
      description: "Descripción",
      financingAvailable: "Financiación",
      photoUrls: "URLs de fotos",
      engineSize: "Cilindraje",
      doors: "Puertas",
      internalPlate: "Placa interna",
      internalVin: "VIN interno",
      soatStatus: "SOAT",
      tecnomecanicaStatus: "Tecnomecánica",
      ownershipCount: "Propietarios",
      accidentHistoryNote: "Nota accidentes",
      dealerStockNumber: "Código inventario",
      externalListingUrl: "URL externa",
      availabilityStatus: "Disponibilidad",
      lastConfirmedAt: "Última confirmación",
    },
    fieldRequired: " *",
    fieldRecommended: " (recomendado)",
    unmapped: "— Sin mapear —",
    samplePrefix: "Ejemplo:",
    noSample: "Sin muestra",
    title: "Importar inventario",
    subtitle: "Sube un CSV con tus vehículos. Puedes descargar la plantilla oficial de AutoMapa.",
    viewHistory: "Ver historial",
    instructionsTitle: "Instrucciones",
    instructionTemplate: "Usa la plantilla CSV para evitar errores de formato.",
    instructionNormalize: "Separadores de miles en precio y kilometraje se normalizan automáticamente.",
    instructionPhotos: "Fotos: URLs separadas por coma, punto y coma, pipe o salto de línea.",
    instructionFinancing: "Financiación: si / no / true / false.",
    instructionMaxRows: "Máximo 500 filas por archivo.",
    downloadTemplate: "Descargar plantilla CSV",
    csvFile: "Archivo CSV",
    importMode: "Modo de importación",
    publishMode: "Modo de publicación",
    confirmCheckbox: "Confirmo que esta información corresponde al inventario actual del concesionario.",
    processing: "Procesando…",
    continue: "Continuar",
    selectFile: "Selecciona un archivo CSV.",
    confirmRequired: "Confirma que la información corresponde al inventario actual.",
    expectedColumns: "Columnas esperadas ({count})",
    historyTitle: "Historial de importaciones",
    historySubtitle: "Importaciones CSV anteriores y su estado.",
    newImport: "Nueva importación",
    noImports: "Aún no hay importaciones registradas.",
    importInventory: "Importar inventario",
    loadHistoryError: "Error al cargar historial.",
    tableDate: "Fecha",
    tableFile: "Archivo",
    tableStatus: "Estado",
    tableRows: "Filas",
    tableCreated: "Creadas",
    tableUpdated: "Actualizadas",
    tableSkipped: "Omitidas",
    tableErrors: "Errores",
    tableUploadedBy: "Subido por",
    viewDetail: "Ver detalle",
    loadingImport: "Cargando importación…",
    importNotFound: "Importación no encontrada.",
    downloadErrors: "Descargar errores CSV",
    history: "Historial",
    modeLabel: "Modo",
    publishLabel: "Publicación",
    mapColumnsTitle: "Mapear columnas",
    mapColumnsDesc: "Asigna cada campo obligatorio a una columna del archivo.",
    generatePreview: "Generar vista previa",
    previewTitle: "Vista previa",
    previewDesc: "Revisa filas válidas, advertencias y duplicados.",
    saveActions: "Guardar acciones",
    confirmImport: "Confirmar importación",
    importing: "Importando…",
    resultsTitle: "Resultados",
    resultsSummary: "Creadas: {created} · Actualizadas: {updated} · Omitidas: {skipped} · Errores: {errors}",
    viewInventory: "Ver inventario",
    rowLink: "Fila {row}: {action} → listing",
    summaryTotalRows: "Filas totales",
    summaryValid: "Válidas",
    summaryWarnings: "Con advertencias",
    summaryErrors: "Con errores",
    summaryDuplicates: "Posibles duplicados",
    summaryCreated: "Creadas",
    summaryUpdated: "Actualizadas",
    summarySkipped: "Omitidas",
    previewEmpty: "No hay filas para mostrar.",
    previewColNumber: "#",
    previewColVehicle: "Vehículo",
    previewColPrice: "Precio",
    previewColMileage: "Km",
    previewColCity: "Ciudad",
    previewColStatus: "Estado",
    previewColWarnings: "Advertencias",
    previewColErrors: "Errores",
    previewColDuplicate: "Duplicado",
    previewColAction: "Acción",
  },
  login: {
    eyebrow: "AutoMapa · Concesionarios",
    title: "Iniciar sesión",
    subtitle: "Administra inventario y leads de tu concesionario.",
    email: "Correo",
    password: "Contraseña",
    submitting: "Ingresando…",
    submit: "Ingresar",
    backToAutoMapa: "Volver a AutoMapa",
    errors: {
      signInFailed: "No se pudo iniciar sesión.",
      invalidCredentials: "Correo o contraseña incorrectos.",
    },
  },
  leadStatus: {
    new: "Nuevo",
    routed: "Enrutado",
    whatsapp_opened: "WhatsApp abierto",
    contacted: "Contactado",
    no_response: "Sin respuesta",
    test_drive_scheduled: "Test drive agendado",
    negotiating: "Negociando",
    sold: "Vendido",
    lost: "Perdido",
    bad_lead: "Mala calidad",
    archived: "Archivado",
  },
  leadTemperature: {
    alta_intencion: "Alta intención",
    buena_oportunidad: "Buena oportunidad",
    explorando_opciones: "Explorando opciones",
    investigacion_inicial: "Investigación inicial",
  },
  leadType: {
    listing_inquiry: "Consulta vehículo",
    quiz_request: "Solicitud quiz",
    recommendation_inquiry: "Recomendación",
    dealer_contact: "Contacto concesionario",
    financing_interest: "Financiación",
    test_drive_request: "Test drive",
    video_request: "Video",
    price_request: "Precio",
    availability_request: "Disponibilidad",
  },
  leadOutcome: {
    not_set: "Sin definir",
    contacted: "Contactado",
    no_response: "Sin respuesta",
    test_drive_scheduled: "Test drive agendado",
    negotiating: "Negociando",
    sold: "Vendido",
    lost_price: "Perdido — precio",
    lost_financing: "Perdido — financiación",
    lost_vehicle_unavailable: "Perdido — vehículo no disponible",
    lost_buyer_not_ready: "Perdido — comprador no listo",
    bad_contact_info: "Datos incorrectos",
    duplicate_lead: "Duplicado",
    spam_or_fake: "Spam o falso",
    other: "Otro",
  },
  leadQuality: {
    excellent: "Excelente",
    good: "Buena",
    okay: "Regular",
    poor: "Mala",
    bad: "Muy mala",
  },
  leadQualityTag: {
    serious_buyer: "Comprador serio",
    correct_budget: "Presupuesto correcto",
    ready_to_buy: "Listo para comprar",
    good_contact_info: "Buen contacto",
    wrong_budget: "Presupuesto incorrecto",
    did_not_respond: "No respondió",
    bad_phone_number: "Teléfono incorrecto",
    vehicle_unavailable: "Vehículo no disponible",
    too_far_away: "Muy lejos",
    not_interested: "No interesado",
    duplicate: "Duplicado",
    spam: "Spam",
  },
  leadQuickAction: {
    contacted: "Contactado",
    no_response: "Sin respuesta",
    test_drive_scheduled: "Test drive",
    negotiating: "Negociando",
    sold: "Vendido",
    lost: "Perdido",
    bad_lead: "Mala calidad",
    archived: "Archivar",
  },
  leadSort: {
    newest: "Más recientes",
    oldest: "Más antiguos",
    score_desc: "Mayor puntaje",
    updated_desc: "Actualizados recientemente",
    timeline_urgent: "Timeline más urgente",
  },
  listingStatus: {
    draft: "Borrador",
    active: "Activo",
    needs_review: "Revisión",
    paused: "Pausado",
    sold: "Vendido",
    archived: "Archivado",
    rejected: "Rechazado",
    available: "Disponible",
    pending_confirmation: "Confirmar",
    reserved: "Reservado",
    unknown: "Desconocido",
  },
  inventorySort: {
    updated_desc: "Actualizado recientemente",
    created_desc: "Más nuevo",
    price_desc: "Precio mayor",
    price_asc: "Precio menor",
    year_desc: "Año más reciente",
    mileage_asc: "Menor kilometraje",
    quality_asc: "Calidad más baja",
  },
  trialReadiness: {
    strong_candidate: "Candidato fuerte",
    needs_more_leads: "Necesita más leads",
    needs_inventory_cleanup: "Inventario por mejorar",
    poor_response: "Respuesta lenta",
    insufficient_data: "Datos insuficientes",
  },
  listingAction: {
    add_photos: "Agrega fotos",
    confirm_availability: "Confirma disponibilidad",
    improve_description: "Mejora descripción",
    review_price: "Revisa precio",
    respond_leads: "Responde leads",
    mark_sold: "Marca como vendido",
    edit_listing: "Editar publicación",
  },
  server: {
    responseTimePlaceholder: "Se calculará cuando empieces a actualizar estados de leads.",
    checklist: {
      confirm_inventory: "Confirmar disponibilidad de vehículos",
      add_photos: "Agregar fotos faltantes",
      respond_leads: "Responder leads nuevos",
      update_outcomes: "Actualizar leads sin resultado",
      complete_profile: "Completar perfil del concesionario",
      review_quality: "Revisar vehículos con baja calidad",
      upload_inventory: "Subir nuevo inventario",
    },
    alerts: {
      needs_confirmation: {
        message: {
          one: "{count} vehículo necesita confirmación de disponibilidad",
          other: "{count} vehículos necesitan confirmación de disponibilidad",
        },
        action: "Confirmar inventario",
      },
      missing_photos: {
        message: {
          one: "{count} vehículo sin fotos",
          other: "{count} vehículos sin fotos",
        },
        action: "Agregar fotos",
      },
      missing_price_mileage: {
        message: {
          one: "{count} vehículo con precio o kilometraje faltante",
          other: "{count} vehículos con precio o kilometraje faltante",
        },
        action: "Revisar inventario",
      },
      low_quality: {
        message: {
          one: "{count} vehículo con calidad baja (< 70)",
          other: "{count} vehículos con calidad baja (< 70)",
        },
        action: "Mejorar calidad",
      },
      sold_still_public: {
        message: {
          one: "{count} listing vendido aún visible",
          other: "{count} listings vendidos aún visibles",
        },
        action: "Corregir estado",
      },
      recent_imports: {
        message: {
          one: "{count} importación reciente",
          other: "{count} importaciones recientes",
        },
        action: "Ver importaciones",
      },
    },
    profileHealth: {
      labels: {
        excellent: "Excelente",
        good: "Bueno",
        needsWork: "Necesita mejorar",
        incomplete: "Incompleto",
      },
      items: {
        verified: "Verificado",
        verificationPending: "Verificación pendiente",
        publicProfile: "Perfil público visible",
        logo: "Logo",
        cover: "Imagen de portada",
        description: "Descripción",
        address: "Ciudad / dirección",
        whatsapp: "WhatsApp",
        financing: "Financiación configurada",
        listings: "Inventario activo",
      },
    },
    trial: {
      active: "Te quedan {days} días en el programa fundador.",
      ending_soon: "Tu prueba termina pronto. Mantén tu inventario actualizado para recibir mejores leads.",
      expired: "La prueba terminó. Contacta a AutoMapa para revisar resultados y próximos pasos.",
      converted: "Tu concesionario completó la prueba fundadora. Gracias por confiar en AutoMapa.",
      declined: "La prueba no continuó. Contacta a AutoMapa si deseas revisar opciones.",
      not_started: "Aún no has iniciado el programa fundador.",
    },
    plan: {
      featuredUpgrade: "Tu plan actual no incluye publicaciones destacadas. Habla con AutoMapa para revisar opciones.",
      descriptions: {
        free: "Presencia básica y trial limitado para concesionarios nuevos.",
        starter: "Plan pequeño para concesionarios con inventario moderado.",
        growth: "Plan activo con más leads, reportes y visibilidad.",
        premium: "Alta visibilidad, placement destacado y soporte prioritario.",
        custom: "Límites y términos configurados manualmente por AutoMapa.",
      },
      warnings: {
        listing_limit: {
          message: "Tu plan actual permite hasta {listingLimit} publicaciones activas. Para publicar más vehículos, habla con AutoMapa sobre un plan superior.",
        },
        lead_limit: {
          message: "Llegaste al límite mensual de leads de tu plan. Contacta a AutoMapa para revisar opciones.",
        },
        lead_limit_near: {
          message: "Estás cerca del límite mensual de leads de tu plan.",
        },
      },
    },
    onboardingChecklist: {
      business_name_confirmed: "Nombre comercial confirmado",
      public_name_confirmed: "Nombre público confirmado",
      logo_added: "Logo/foto del concesionario",
      address_confirmed: "Dirección confirmada",
      city_neighborhood_confirmed: "Ciudad/barrio confirmados",
      whatsapp_confirmed: "WhatsApp principal confirmado",
      contact_person_confirmed: "Persona de contacto confirmada",
      public_profile_reviewed: "Perfil público revisado",
      verification_reviewed: "Verificación revisada",
      inventory_file_received: "Archivo de inventario recibido",
      inventory_imported: "Inventario importado",
      listings_cleaned: "Publicaciones limpiadas",
      listings_have_photos: "Publicaciones con fotos",
      listings_have_price_mileage: "Precio y kilometraje completos",
      listings_confirmed_available: "Disponibilidad confirmada",
      min_ten_active_listings: "Al menos 10 publicaciones activas",
      lead_inbox_reviewed: "Bandeja de leads revisada",
      whatsapp_routing_tested: "Enrutamiento WhatsApp probado",
      dashboard_reviewed: "Dashboard revisado",
      response_expectations_understood: "Expectativas de respuesta explicadas",
      trial_terms_explained: "Términos de prueba explicados",
      launch_ready_approval: "Aprobación launch-ready",
    },
  },
  leadDetail: {
    loading: "Cargando lead…",
    notFound: "Lead no encontrado.",
    backToInbox: "Volver a la bandeja",
    back: "Volver",
    openWhatsapp: "Abrir WhatsApp",
    unnamedLead: "Lead sin nombre",
    hotPill: "Caliente",
    buyer: "Comprador",
    name: "Nombre",
    email: "Email",
    city: "Ciudad",
    consent: "Consentimiento",
    yes: "Sí",
    no: "No",
    purchaseIntent: "Intención de compra",
    temperature: "Temperatura",
    budget: "Presupuesto",
    vehicleType: "Tipo vehículo",
    transmission: "Transmisión",
    fuel: "Combustible",
    financing: "Financiación",
    downPayment: "Cuota inicial",
    timeline: "Timeline",
    useCase: "Uso",
    vehicleListing: "Vehículo / listing",
    viewPublic: "Ver público",
    editInventory: "Editar inventario",
    noLinkedVehicle: "Sin vehículo específico vinculado.",
    source: "Origen",
    created: "Creado",
    workflow: "Flujo del lead",
    status: "Estado",
    assignedSalesperson: "Vendedor asignado",
    salespersonPlaceholder: "Nombre del vendedor",
    nextFollowUp: "Próximo seguimiento",
    saveAssignment: "Guardar asignación",
    outcome: "Resultado",
    outcomeReason: "Razón / detalle",
    outcomeReasonPlaceholder: "Requerido para mala calidad o spam",
    saveOutcome: "Guardar resultado",
    leadQuality: "Calidad del lead",
    rating: "Calificación",
    selectPlaceholder: "Seleccionar…",
    saveRating: "Guardar calificación",
    internalNotes: "Notas internas",
    notePlaceholder: "Agregar nota para el equipo…",
    addNote: "Agregar nota",
    eventHistory: "Historial de eventos",
    whatsappPreview: "Vista previa mensaje WhatsApp",
    errors: {
      updateStatus: "Error al actualizar estado.",
      saveNote: "Error al guardar nota.",
      saveOutcome: "Error al guardar resultado.",
      saveRating: "Error al guardar calificación.",
      saveAssignment: "Error al guardar asignación.",
      invalidWhatsapp: "No hay número de WhatsApp válido para este comprador.",
    },
  },
  buyerInterest: {
    title: "Interés de compradores",
    demandPanelTitle: "Demanda del inventario",
    demandPanelIntro: "Señales agregadas de guardados, comparaciones y alertas de precio en tu inventario.",
    listingSectionTitle: "Interés de compradores",
    viewDemandPanel: "Ver demanda completa",
    backToInventory: "Volver al inventario",
    privacyNote: "Los conteos son agregados para proteger la privacidad de los compradores.",
    loadError: "No se pudo cargar el interés de compradores.",
    likes: "Favoritos",
    compares: "Comparaciones",
    watchers: "Alertas de precio",
    kpiLikes: "Favoritos en inventario activo",
    kpiCompares: "Comparaciones agregadas",
    kpiWatchers: "Alertas de precio activas",
    kpiRising: "Con tendencia al alza",
    topLikedVehicle: "Vehículo más guardado",
    topFiveTitle: "Top 5 vehículos guardados",
    emptyInventoryTitle: "No hay inventario activo",
    emptyInventoryBody:
      "El interés de compradores aparecerá aquí cuando tus publicaciones activas reciban guardados, comparaciones o alertas de precio.",
    emptyInterestTitle: "Aún no hay interés de compradores",
    emptyInterestBody:
      "Cuando los compradores guarden, comparen o vigilen tus vehículos, verás insights agregados aquí.",
    belowThreshold: "Datos insuficientes para mostrar conteos detallados.",
    demandLabel: "Señal de demanda",
    risingTrend: "Guardados en aumento esta semana",
    refreshCounts: "Actualizar conteos",
    sortLabel: "Ordenar",
    statusLabel: "Estado",
    statusAll: "Todos",
    colVehicle: "Vehículo",
    colPrice: "Precio",
    colDemand: "Demanda",
    colStatus: "Estado",
    colActions: "Acciones",
    prevPage: "Anterior",
    nextPage: "Siguiente",
    ranges: {
      "7d": "Últimos 7 días",
      "30d": "Últimos 30 días",
      all: "Todo el tiempo",
    },
    sort: {
      likes: "Más guardados",
      compares: "Más comparados",
      watches: "Más alertas de precio",
      updated: "Actualizados recientemente",
      price: "Mayor precio",
    },
    demand: {
      noData: "Sin datos suficientes",
      lowInterest: "Interés bajo",
      moderateInterest: "Interés moderado",
      highInterest: "Alto interés",
      priceSensitive: "Sensibilidad al precio",
    },
    insights: {
      strongSaveActivity: "Este vehículo tiene alto volumen de guardados.",
      watchingForLowerPrice: "Varios compradores están atentos a una reducción de precio.",
      highSavesLowContact:
        "Muchos guardados pero poca actividad de contacto puede indicar sensibilidad al precio.",
      confirmAvailability:
        "Este vehículo tiene alto volumen de guardados. Considera confirmar disponibilidad o revisar el precio.",
    },
  },
};
